import { render } from "./SimpleArray.vue?vue&type=template&id=02501a66"
import script from "./SimpleArray.vue?vue&type=script&lang=js"
export * from "./SimpleArray.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__